import {
  SET_SHOW_NOTIFICATIONS_OPT_IN_SUCCESS_BANNER,
  OPT_IN_TO_NOTIFICATIONS
} from "../../constants";
import { ERROR } from "../../../../../state/modules/common/constants";
import { updateNotificationsPreference } from "../../../../../services/preferences";
import { getNotificationsOptInBucket } from "../../../../../state/modules/savedItems/selectors";
import { LoggedError } from "../../../../../services/errors";
import notificationsOptInResponseEvent from "../../../../../services/dataLayer/notificationsOptInResponseEvent";

export const optInToNotifications = () => async (dispatch, getState) => {
  try {
    await updateNotificationsPreference();
    const bucket = getNotificationsOptInBucket(getState());
    notificationsOptInResponseEvent("success");
    dispatch({
      type: SET_SHOW_NOTIFICATIONS_OPT_IN_SUCCESS_BANNER,
      payload: { show: true, isSuccess: true, bucket }
    });
  } catch (e) {
    new LoggedError(e, LoggedError.error);
    notificationsOptInResponseEvent("error", "marketing_opt_in_error");
    dispatch({
      type: ERROR,
      payload: {
        failedActionType: OPT_IN_TO_NOTIFICATIONS,
        canBeRetried: false
      }
    });
  }
};
